import React from 'react';
import { Button } from '@mui/material';
import { privateRoutesPath } from '../Routes';
import { handleValidateCodevalue } from '../Utility/constant';
import { useSelector } from 'react-redux';
import useNavigation from '../Utility/hooks/useNavigation';

const NavigationBackButton = ({ 
    targetTab,
    targetPath = privateRoutesPath.PRODUCT,
    className = 'edit-primary btn-space',
    variant = "outlined",
    label,
    additionalState = {},
    ...props 
}) => {
    const { navigateTo } = useNavigation();
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const handleBackNavigation = () => {
        navigateTo(targetPath,
            {
                goToMenu: targetTab,
                ...additionalState
            });
    };

    return (
        <Button 
            className={className} 
            variant={variant} 
            onClick={handleBackNavigation}
            {...props}
        >
            {label || handleValidateCodevalue(internationalise, 'COMMON_BACK')}
        </Button>
    );
};

export default NavigationBackButton;
